import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

import imgSunday from '../Assets/NewsAndEvents/SundayService.png';
import imgRoundtable from '../Assets/NewsAndEvents/McRoundTable.png';
import imgYouth from '../Assets/NewsAndEvents/TheChristGeneration.png';
import imgRoyalWomen from '../Assets/NewsAndEvents/RoyalLadiesFellowship.png';
import imgMegaMc from '../Assets/NewsAndEvents/MegaMc.png';
import imgKingsmen from '../Assets/NewsAndEvents/KingsMenFellowship.png';
import imgMoneyMatters from '../Assets/NewsAndEvents/MoneyMattersForum.png';

const PROGRAMS = [
  {
    src: imgSunday,
    tag: 'Every Sunday',
    label: 'Sunday Service',
    alt: 'Sunday Service at The City Church',
    text: 'Join us every Sunday for uplifting worship, life-giving biblical messages, and warm community across all our campuses.',
    path: '/service-times',
  },
  {
    src: imgRoundtable,
    tag: 'Every Thursday',
    label: 'RoundTable Discussions',
    alt: 'RoundTable Discussions in missional communities',
    text: 'Thursdays, 5:30 to 7:00 PM in our missional communities. We reflect together deeply on the past Sunday’s message.',
    path: '/weekly-round-table',
  },
  {
    src: imgYouth,
    tag: 'Last Saturday Monthly',
    label: 'The Youth Experience (TCG)',
    alt: 'The Youth Experience with The Christ Generation',
    text: 'Every last Saturday of the month: dynamic youth worship, empowering Word, fun, prayer, and life-changing community.',
    path: '/tcg-page',
  },
  {
    src: imgRoyalWomen,
    tag: 'Monthly Fellowship',
    label: 'Royal Ladies Fellowship',
    alt: 'Royal Ladies Fellowship at The City Church',
    text: 'Empowering women in faith, purposeful sisterhood, family wisdom, and spiritual leadership.',
    path: '/join-mc',
  },
  {
    src: imgMegaMc,
    tag: 'Monthly Gathering',
    label: 'Mega MC Gathering',
    alt: 'Mega MC Gathering united fellowship',
    text: 'Monthly united gathering of all missional communities across Kampala for praise, testimonies, and fellowship.',
    path: '/join-mc',
  },
  {
    src: imgKingsmen,
    tag: 'Last Sunday Monthly',
    label: 'The Kings Men Fellowship',
    alt: 'The Kings Men Fellowship at The City Church',
    text: 'Building strong, godly men through honest brotherhood, spiritual leadership, and active accountability.',
    path: '/join-mc',
  },
  {
    src: imgMoneyMatters,
    tag: 'Special Forum',
    label: 'The Money Matters Forum',
    alt: 'The Money Matters Forum with Dr. Alex Mutagubya',
    text: 'Practical, faith-rooted financial leadership, budgeting, investments, and biblical kingdom stewardship.',
    path: '/financial',
  },
];

function Cards() {
  return (
    <section className="tcc-section programs" id="programs" aria-labelledby="programs-heading" style={{ scrollMarginTop: '96px' }}>
      <div className="tcc-container">
        <div className="programs__head">
          <p className="tcc-eyebrow">Get involved</p>
          <h2 className="tcc-h2" id="programs-heading">Our Programs &amp; Ministries</h2>
          <p className="tcc-lead">
            There’s a place for every season of life. Explore the ways you can
            connect, grow and serve with us.
          </p>
        </div>

        <ul className="programs__grid">
          {PROGRAMS.map((p) => (
            <CardItem key={p.label} {...p} />
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Cards;
